import { createFeature, createReducer, on } from '@ngrx/store'
import { initialState } from './tax-settings.state'
import { taxSettingsActions } from './tax-settings.actions'

export const taxSettingsReducer = createReducer(
  initialState,

  //Load All Financial Years
  on(taxSettingsActions.loadFinancialYearsSuccess, (state, { financialYears }) => ({
    ...state,
    financialYears,
    loading: false
  })),
  on(taxSettingsActions.loadFinancialYearsFailure, ({ error }) => ({
    ...initialState,
    error
  })),
  //Load Tax Settings for a Financial Year
  on(taxSettingsActions.loadSlabsAndRulesSuccess, (state, { fyTaxSettings }) => ({
    ...state,
    fyTaxSettings,
    loading: false
  })),
  on(taxSettingsActions.loadSlabsAndRulesFailure, ({ error }) => ({
    ...initialState,
    error
  }))
)

export const taxSettingsFeature = createFeature({
  name: 'taxSettings',
  reducer: taxSettingsReducer
})

export const {
  name,
  reducer,
  selectLoading,
  selectError,
  selectFinancialYears,
  selectFyTaxSettings
} = taxSettingsFeature
